<template>
  <div class="import-jobs permission-zone-import">
    <el-dialog :title="`Настройка доступа к зонам`" :visible.sync="dialogObject">
      <div class="add-jobs" v-show="!objectId" v-if="dialogObject">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div style="margin-top: 20px; margin-bottom: 10px; display: flex">
          <el-switch
            v-model="usePermission"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <strong style="margin-left: 10px">Выкл/Вкл настройки доступов</strong>
        </div>
        <el-table
          row-key="id"
          @select="handleSelectionChangeObject"
          @select-all="handleSelectionChangeObject"
          empty-text="Объекты не найдены"
          ref="multipleObjectTable"
          :data="filteredList"
          style="width: 100%"
        >
          <el-table-column
            v-if="usePermission"
            property="check"
            type="selection"
            width="36"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="Объекты"
          >
          </el-table-column>
          <el-table-column
            width="50px"
          >
          </el-table-column>
          <el-table-column
            width="50px"

          >
            <template slot-scope="scope">
              <div v-if="defaultZone !== scope.row.id">
                <el-radio v-model="defaultZone" :name="scope.row.id" :label="scope.row.id"></el-radio>
              </div>
              <div v-else @click="clickDefault(scope.row.id)">
                <el-radio style="pointer-events: none" :value="defaultZone" :name="scope.row.id"
                          :label="scope.row.id"></el-radio>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--        <div class="jobs-ul">-->
        <!--          <div-->
        <!--            @click="selectObject(list)"-->
        <!--            class="jobs-li" v-for="(list, index) in filteredList" :key="index"-->
        <!--          >-->
        <!--            <span>{{ list.name }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="create-footer">
        <el-button @click="back" v-if="objectId">Назад</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';

export default {
  name: 'PermissionZone',
  props: ['name', 'planId', 'versionId', 'onlyObject'],
  data() {
    return {
      user: {},
      id: null,
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      selectedJob: [],
      loading: false,
      defaultZone: null,
      availableJobs: {},
      availableObjects: [],
      usePermission: false,
      list: [],
      jobs: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  watch: {
    filteredList: _.debounce(function () {
      this.filteredList.map((row) => {
        const availableObjects = this.availableObjects.map((a) => a.id);
        if (availableObjects.includes(row.id) || (this.user.available_objects && this.user.available_objects.includes(row.id))) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
  },

  mounted() {
    this.fetchTree();
  },

  methods: {
    clickDefault(name) {
      if (name === this.defaultZone) {
        this.defaultZone = null
      }
    },
    fire() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },

    back() {
      this.objectId = null;
    },
    openDialog(user) {
      this.dialogObject = true;
      this.user = user
      this.id = user.id
      setTimeout(() => {
        this.usePermission = this.user.usePermission;
        // this.availableJobs = this.user.available_jobs;
        this.list.map((row) => {
          if (this.user.available_objects && this.user.available_objects.includes(row.id)) {
            this.$refs.multipleObjectTable.toggleRowSelection(row);
            this.availableObjects.push(row);
          }
        })
      }, 100);

      this.defaultZone = this.user.defaultZone || null
    },
    handleSelectionChangeObject(selected) {
      this.selectedObjects = selected;
      this.availableObjects = this.list.filter((s) => {
        return this.selectedObjects.find((l) => l.id === s.id)
      });
    },
    handleSelectionChangeJob(selected) {
      this.selectedJob = selected;

      const available = [];
      if (Array.isArray(this.availableJobs)) {
        this.availableJobs = {};
      }

      this.availableJobs[this.objectId].map((d) => {
        if (this.selectedJob.find((s) => d.id === s.id)) {
          available.push(d);
        }
      })

      this.availableJobs[this.objectId] = [...available, ...this.jobs.filter((s) => {
        return this.selectedJob.find((l) => l.id === s.id);
      })];
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('zones')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          ..._.orderBy(getChildList(result), 'index', ['asc']),
        ];
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;
      const availableJobs = {}
      const available_jobs_bigquery = []
      const users_jobs = this.user.available_jobs;

      Object.entries(this.availableJobs).forEach(([key, value]) => {
        availableJobs[key] = _.uniq(value.map((o) => o.id))

        availableJobs[key].forEach((e) => {
          available_jobs_bigquery.push({
              "object_id": key,
              "job_id": e
            },
          )
        })
      })

      if (!this.planId && !this.versionId) {
        console.log(this.$store.state.project.id, this.id)
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('dirs')
          .doc(this.id)
          .update({
            defaultZone: this.defaultZone,
            usePermission: this.usePermission,
            available_jobs: {...users_jobs, ...availableJobs},
            available_objects: _.uniq(this.availableObjects.map((o) => o.id))
          }).then((add) => {
          this.$notify({
            offset: 60,
            title: 'Успешно',
            message: 'Доступ разделу изменен',
            type: 'success',
          });
          this.$emit('fetchTree')
        }).catch((error) => {
          this.$notify({
            offset: 60,
            title: 'Упс... ',
            message: 'Произошла ошибка повторите позже',
            type: 'error',
          });
        });
      }
      //
      // batch.commit().then((response) => {
      // this.loading = false;
      // this.$notify({
      //   offset: 60,
      //   title: 'Успешно!',
      //   message: 'Доступы изменены',
      //   type: 'success',
      // });
      this.$emit('update', {
        ...this.user,
        usePermission: this.usePermission,
        available_jobs: {...users_jobs, ...availableJobs},
        available_jobs_bigquery,
        available_objects: _.uniq(this.availableObjects.map((o) => o.id))
      });
      if (this.objectId) {
        return this.objectId = null;
      } else {
        this.close();
      }
      // });
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selectedJob = [];
      this.selectedObjects = [];
      this.search = '';
    },
  },
};
</script>

<style lang="scss">
.permission-zone-import {
  .el-radio__label {
    display: none;
  }


  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    .el-select .el-input {
      width: 142px;
    }
  }
}
</style>
<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Dirs/components/PermissionZone.vue